module.exports = __webpack_public_path__ + "img/Paul.6cbe3953.jpg";